import React from 'react';
import ReactDOM from 'react-dom';
import ConfirmModal from '../../components/molecules/Modal';

let modalRoot: HTMLElement | null = null;

const createModalRoot = () => {
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.id = 'modal-root';
    document.body.appendChild(modalRoot);
  }
  return modalRoot;
};

export const showModal = ({
  title = '',
  message = '',
  confirmText = '확인',
  cancelText = '취소',
  shouldCloseOnOverlayClick = true,
  shouldCloseOnEsc = true,
}: {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
}): Promise<boolean> => {
  return new Promise((resolve) => {
    const modalRoot = createModalRoot();

    const handleConfirm = () => {
      cleanup();
      resolve(true);
    };

    const handleCancel = () => {
      cleanup();
      resolve(false);
    };

    const cleanup = () => {
      // React 16에서는 unmountComponentAtNode가 정상적으로 작동
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.unmountComponentAtNode(modalRoot);
    };

    // React 18에서는 render가 더 이상 사용되지 않음
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(
      <ConfirmModal
        isOpen={true}
        onClose={handleCancel}
        title={title}
        subText={message}
        confirmText={confirmText}
        cancelText={cancelText}
        onConfirm={handleConfirm}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        shouldCloseOnEsc={shouldCloseOnEsc}
      />,
      modalRoot
    );
  });
};
